import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import LiveSDK from "@saas/live-sdk";
import { uploadLiveLog } from "@saas/components/src/utils/log";
export default {
  data() {
    return {
      _createTrtcLiveServiceHandlers: {},
    };
  },
  beforeDestroy() {
    Object.keys(this._createTrtcLiveServiceHandlers).forEach((eventName) => {
      this.liveService.off(
        eventName,
        this._createTrtcLiveServiceHandlers[eventName]
      );
    });
  },
  computed: {
    ...mapState("live", [
      "liveService",
      "signConfig",
      "roomInfo",
      "microphoneList",
      "speakerList",
      "cameraList",
    ]),
  },
  methods: {
    ...mapMutations("live", [
      "setCameraList",
      "setLiveService",
      "setMicrophoneList",
      "setSpeakerList",
      "setCurrentCameraDevice",
      "setCurrentMicDevice",
      "setCurrentSpeakerDevice",
      "setDeviceSwtich",
      "setVideoPermission",
    ]),
    createTrtc() {
      try {
        console.log("createTrtc", this.signConfig);
        const liveSign = this.signConfig.live_sig;
        const userId = this.signConfig.user_id;
        const isRecordPage = !!this.$route.query.token;
        const config = {
          providers: {
            live: "trtc",
          },
          live: {
            trtc: {
              sdkAppId: liveSign.sdk_app_id,
              userSig: liveSign.user_sig,
              userId: userId,
              roomId: this.roomInfo.id,
              role: 1,
              isRecord: isRecordPage,
              privateMapKey: this.signConfig.PrivateMapKey,
              mode: this.roomInfo.mode,
              resolution: +this.$route.query.resolution || "",
            },
          },
        };
        const liveSDK = LiveSDK.init(config);
        this.setLiveService(liveSDK.getService("live"));
        this.getCameraList();
        this.getMicrophoneList();
        this.getSpeakerDevicesList();
        this._createTrtcLiveServiceHandlers = {
          deviceChange: (params) => {
            const { type, deviceId, state } = params;
            console.log(
              "device_deviceChange_设备变化了,添加或者删除设备",
              params
            );
            if (type === "microphone") {
              this.getMicrophoneList();
            } else if (type === "speaker") {
              this.getSpeakerDevicesList();
            } else if (type === "camera") {
              this.getCameraList();
            }
            uploadLiveLog({
              message: "device_deviceChange_设备变化了,添加或者删除设备",
              level: "info",
              tag: "callback",
              extra: {
                component: "create-trtc",
                params: params,
              },
            });
          },
          defaultDeviceChange: (params) => {
            console.log(
              "device_defaultDeviceChange_系统默认设备变化了",
              params
            );
            uploadLiveLog({
              message: "device_defaultDeviceChange_系统默认设备变化了",
              level: "info",
              tag: "callback",
              extra: {
                component: "create-trtc",
                params: params,
              },
            });
          },
          deviceActive: (params) => {
            console.log("device_active_设备启动了", params);
            const { type, deviceId } = params;
            if (type === "microphone") {
              this.setCurrentMicDevice({ deviceId, setFrom: "callback" });
            } else if (type === "speaker") {
              this.setCurrentSpeakerDevice({ deviceId, setFrom: "callback" });
            } else if (type === "camera") {
              this.setCurrentCameraDevice({ deviceId, setFrom: "callback" });
            }
            uploadLiveLog({
              message: "device_active_设备启动了",
              level: "info",
              tag: "callback",
              extra: {
                component: "create-trtc",
                params: params,
              },
            });
          },
          error: (params) => {
            console.log("error_error_错误", params);
            uploadLiveLog({
              message: "trtc_error_错误",
              level: "error",
              tag: "callback",
              extra: {
                component: "create-trtc",
                error: params,
              },
            });
          },
        };
        Object.keys(this._createTrtcLiveServiceHandlers).forEach(
          (eventName) => {
            this.liveService.on(
              eventName,
              this._createTrtcLiveServiceHandlers[eventName]
            );
          }
        );
        // this.liveService.on("deviceChange", (params) => {
        //   const { type, deviceId, state } = params;
        //   console.log(
        //     "device_deviceChange_设备变化了,添加或者删除设备",
        //     params
        //   );
        //   if (type === "microphone") {
        //     this.getMicrophoneList();
        //   } else if (type === "speaker") {
        //     this.getSpeakerDevicesList();
        //   } else if (type === "camera") {
        //     this.getCameraList();
        //   }
        //   uploadLiveLog({
        //     message: "device_deviceChange_设备变化了,添加或者删除设备",
        //     level: "info",
        //     tag: "callback",
        //     extra: {
        //       component: "create-trtc",
        //       params: params,
        //     },
        //   });
        // });
        // this.liveService.on("defaultDeviceChange", (params) => {
        //   console.log("device_defaultDeviceChange_系统默认设备变化了", params);
        //   uploadLiveLog({
        //     message: "device_defaultDeviceChange_系统默认设备变化了",
        //     level: "info",
        //     tag: "callback",
        //     extra: {
        //       component: "create-trtc",
        //       params: params,
        //     },
        //   });
        // });
        // this.liveService.on("deviceActive", (params) => {
        //   console.log("device_active_设备启动了", params);
        //   const { type, deviceId } = params;
        //   if (type === "microphone") {
        //     this.setCurrentMicDevice({ deviceId, setFrom: "callback" });
        //   } else if (type === "speaker") {
        //     this.setCurrentSpeakerDevice({ deviceId, setFrom: "callback" });
        //   } else if (type === "camera") {
        //     this.setCurrentCameraDevice({ deviceId, setFrom: "callback" });
        //   }
        //   uploadLiveLog({
        //     message: "device_active_设备启动了",
        //     level: "info",
        //     tag: "callback",
        //     extra: {
        //       component: "create-trtc",
        //       params: params,
        //     },
        //   });
        // });
        // this.liveService.on("error", (params) => {
        //   console.log("error_error_错误", params);
        //   uploadLiveLog({
        //     message: "trtc_error_错误",
        //     level: "error",
        //     tag: "callback",
        //     extra: {
        //       component: "create-trtc",
        //       error: params,
        //     },
        //   });
        // });
        setTimeout(() => {
          const defaultMic = this.microphoneList.find((item) => item.isDefault);
          const defaultSpeaker = this.speakerList.find(
            (item) => item.isDefault
          );
          if (defaultMic) {
            this.setCurrentMicDevice({
              deviceId: defaultMic.deviceId,
            });
          }
          if (defaultSpeaker) {
            this.setCurrentSpeakerDevice({
              deviceId: defaultSpeaker.deviceId,
            });
          }
        }, 1000);
      } catch (error) {
        uploadLiveLog({
          message: "创建trtc---失败",
          level: "error",
          extra: {
            component: "create-trtc",
            error: error,
          },
        });
      }
    },
    // 获取摄像头列表
    getCameraList() {
      this.liveService.getCameraList().then((res) => {
        console.log("摄像头列表", res);
        const list = res.filter((item) => item.deviceId) || [];
        this.setCameraList(list);
        if (list.length === 0) {
          // 如果没有摄像头
          this.setVideoPermission(false);
        }
      });
    },
    // 获取麦克风列表
    getMicrophoneList() {
      this.liveService.getMicrophoneList().then((res) => {
        console.log("麦克风列表", res);
        const list = res.filter((item) => item.deviceId) || [];
        this.setMicrophoneList(list);
      });
    },
    // 获取扬声器列表
    getSpeakerDevicesList() {
      this.liveService.getSpeakerDevicesList().then((list) => {
        console.log("扬声器列表____", list);
        this.setSpeakerList(list || []);
      });
    },
  },
};
